import { graphqlClient } from '@/core/api/graphql-client'
import { UserDocument } from '@/generated/graphql'

// Single source of truth for the authenticated-user ("me") query. Shared so the
// /config gate and the app-load prefetch observe the same ['user'] cache entry
// that the auth flow + pages already populate.
export const userQueryOptions = {
  queryKey: ['user'] as const,
  queryFn: () => graphqlClient.request(UserDocument),
}
